// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");

function TogglesGroup(props) {
  var __inline = props.inline;
  var inline = __inline !== undefined ? __inline : false;
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: TailwindMerge.twMerge([
                    "flex items-start flex-col space-y-2.5",
                    inline ? "md:flex-row md:space-y-0 md:space-x-6" : ""
                  ])
            });
}

var make = TogglesGroup;

exports.make = make;
/* tailwind-merge Not a pure module */
